import React, { useEffect } from 'react';
import '../styles/Platforms.css';

const platforms = [
  {
    title: "Betway",
    image: "1xbet.webp",
  },
  {
    title: "Bet365",
    image: "10cric.webp",
  },
  {
    title: "JeetWin",
    image: "cricketbet99.webp",
  },
  {
    title: "IndiBet",
    image: "dafabet.webp",
  },
  {
    title: "Rajabets",
    image: "fun88.webp",
  },
  {
    title: "SkyExchange",
    image: "laser.webp",
  },
  {
    title: "FairPlay",
    image: "Parimatch.webp",
  },
  {
    title: "Sportaza",
    image: "stake.webp",
  },
  {
    title: "WinDaddy",
    image: "11xplayplatforms.webp",
  },
];

const Platforms = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const message = "Need Cricket ID";
  const encodedMessage = encodeURIComponent(message);
  const ContactLink = `https://wa.me/918000047833?text=${encodedMessage}`;
  const whatsappLink = `https://wa.me/918000047833?text=${encodedMessage}`;
  
  return (
    <div className="platforms-page">
      <header className="platforms-hero-section">
        <h1 className="platforms-hero-title">Top <span className='highlight'>Gaming Platforms</span></h1>
        <p className="platforms-hero-description">
          Discover the most trusted and popular platforms in the world of online gaming with Mahadev Book. We collaborate with industry-leading names to provide you seamless, secure, and entertaining betting experiences across sports, casinos, and card games. These platforms are optimized for performance, reliability, and user satisfaction — whether you’re playing for fun or real rewards.
        </p>
      </header>

      <section className="platforms-section">
        <h2 className="platforms-section-title">Explore <span className='highlight'>Our Partners</span></h2>
        <div className="platforms-grid">
          {platforms.map((platform, index) => (
            <div className="platform-card" key={index}>
              <div className="platform-image">
                <img
                  src={platform.image}
                  alt={platform.title}
                />
              </div>
              <div className="platform-name">{platform.title}</div>
            </div>
          ))}
        </div>
        <div className="platforms-btn">
          <a
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="contactus-button"
          >
            Open Your Demo Account
          </a>
          <a
            href={ContactLink}
            target="_blank"
            rel="noopener noreferrer"
            className="contactus-button"
          >
            Contact Us Now
          </a>
        </div>
      </section>
    </div>
  );
};

export default Platforms;
